import { Divider, Text, mergeClasses } from "@fluentui/react-components";
import { SkillsDefaults } from "@/common/constants/skills";
import { SkillVariableModel } from "@/common/models/skills";
import { useStyles } from "./../style";

interface SkillsDisplayProps {
    skills?: SkillVariableModel[];
}

export const SkillsDisplay = ({ skills }: SkillsDisplayProps) => {
    const style = useStyles();

    if (!skills || skills.length === 0) {
        return null;
    }

    return (
        <>
            <Divider />
            <Text
                align="center"
                block
                className={mergeClasses(style.text, style.grayText)}
                truncate
                wrap={false}
                title={skills.map((skill) => skill.name).join(", ")}
            >
                {skills.map((skill, index) => (
                    <span
                        key={skill.name}
                        className={
                            skill.weight === SkillsDefaults.MaxSkillLevel
                                ? style.bold
                                : ""
                        }
                    >
                        {skill.name}
                        {index < skills.length - 1 ? ", " : ""}
                    </span>
                ))}
            </Text>
        </>
    );
};